import { NarrativeHeroProps } from 'lib/components/NarrativeHero/NarrativeHero'

import { ClaimsPageContent } from './shipsticks.page.content'

const hero: NarrativeHeroProps = {
  header: 'ShipSkis Claims Process',
  subHeader:
    'Learn about our claims process and file a claim for damaged, lost, or delayed shipments.',
}

const claimsProcess = {
  title: 'Claims Process',
  steps: [
    {
      title: 'File Claim',
      description:
        'To begin the claims process you will select the appropriate online form below and ' +
        'fill out all required fields. All claims must be filed within 10 days of the ' +
        'actual or scheduled delivery date.',
    },
    {
      title: 'Claim Reviewed',
      description:
        'A claims specialist will review and file your claim within 1-2 business days. ' +
        'If additional information is needed, a claims specialist will contact you by ' +
        'phone or email.',
    },
    {
      title: 'Claim Filed',
      description:
        'Once your claim has been filed you can expect to receive an update on your claim ' +
        'within 7-10 business days. At this time we will notify you if your claim has ' +
        'been approved.',
    },
    {
      title: 'Claim Approved',
      description:
        'Once your claim has been approved we will mail your reimbursement check via USPS. ' +
        'The check will be sent to the address provided in your claims submission.',
    },
  ],
}

const claimsForms = {
  title: 'ShipSkis Claims',
  forms: [
    {
      name: 'Click here to file a claim for Damaged/Missing Items',
      href: '/form/damaged_missing_items_form',
    },
    {
      name: 'Click here to file a Shipment Protection Claim for a delayed package',
      href: '/form/shipment_protection_form',
    },
  ],
}

const contactInfo = {
  title: 'Contact Claims at ShipSkis',
  sections: [
    {
      title: 'Claims Department',
      content: [
        <>
          <strong style={{ display: 'inline!important' }}>Phone:</strong> (866) 761-7547
        </>,
        <>
          <strong style={{ display: 'inline!important' }}>Fax:</strong> (561) 429-3915
        </>,
        <>
          <strong style={{ display: 'inline!important' }}>Email:</strong>{' '}
          <a href="mailto:info@shipskis.com" style={{ display: 'inline!important' }}>
            info@shipskis.com
          </a>
        </>,
      ],
    },
    {
      title: 'Mailing Address',
      content: [
        'ShipSkis Claims Department',
        '1140 N. Jog Road Suite 300',
        'Palm Beach Gardens, FL 33418',
      ],
    },
  ],
}

const content: ClaimsPageContent = {
  hero,
  claimsProcess,
  claimsForms,
  contactInfo,
}

export default content
